/**
 * criado para ficar utilizar os tipos de card como parâmetro de verificação
 */

// Card do gráfico evolutivo
export const EVOLUTIVE_CARD = 'evolutiveChartCard';
// Card do gráfico de cruzamentos simples
export const SIMPLECROSS_CARD = 'simpleCrossChartCard';
// Card do gráfico simples
export const SIMPLE_CARD = 'simpleChartCard';
// Card do gráfico de cruzamentos multiplos
export const MULTIPLE_CARD = 'multipleCrossChartCard';
// Card para gráficos de evolutivo de cruzamentos
export const EVOLUTIVE_CROSS_CARD = 'evolutiveCrossChartCard';
// Card do gráfico de correlação
export const CORRELATION_CARD = 'correlationChartCard';